import React from 'react';
import { Popover } from '@mui/material';

import CustomTooltip from '@/components/common-components/CustomTooltip/CustomTooltip';
import ShortString from '@/components/common-components/ShortString/ShortString';
import TickIcon2 from '@/components/Icons/icons/TickIcon2';

import './_newSingleSelect.scss';

interface OptionsInterface {
  label: string;
  value: string | number;
  isDisabled?: boolean;
  disabledTooltip?: string;
}

interface BasicMenuInterface {
  anchorEl: HTMLDivElement | null;
  onClose: () => void;
  menuItems: OptionsInterface[];
  onSelect: (value: string | number) => void;
  selectedValue: string | number;
  width: number;
  height?: number;
  optionStringLength?: number;
  dropdownStyles?: React.CSSProperties;
  showTick?: boolean;
  fontSize?: string;
}

export const BasicMenu: React.FC<BasicMenuInterface> = ({
  anchorEl,
  onClose,
  menuItems,
  onSelect,
  selectedValue,
  width,
  height = 150,
  optionStringLength,
  dropdownStyles = {},
  showTick = true,
  fontSize = '16px',
}) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        style: {
          backgroundColor: 'white',
          borderRadius: 0,
          zIndex: 99999,
          width,
          maxHeight: height,
          overflow: 'auto',
          padding: '8px',
          ...dropdownStyles,
        },
      }}>
      {menuItems?.map((option) => {
        const active = selectedValue === option.value;
        return (
          <CustomTooltip
            key={option.value}
            show={Boolean(option.isDisabled && option.disabledTooltip)}
            title={option.disabledTooltip}>
            <div
              className={`trigger-drop-down-option-container ${active ? 'trigger-drop-down-option-active' : ''} ${option.isDisabled ? 'text-disabled' : ''}`}
              onClick={() => {
                if (option.isDisabled) return;
                onSelect(option.value);
              }}>
              <ShortString
                name={option.label}
                stringLength={optionStringLength || 32}
                placement="left"
                show={!option.isDisabled}
                style={{ fontSize }}
              />
              {active && showTick ? <TickIcon2 width={14} height={14} color="var(--icon-highlight)" /> : <></>}
            </div>
          </CustomTooltip>
        );
      })}
    </Popover>
  );
};
